import React from "react";
import { FlaskConical } from "lucide-react";
import { STATUS, useWP } from "./wpApi";
import { packageT } from "./packageText";

export default function WPStatusBadge({ status, testid }) {
  const { status: label } = useWP();
  const s = STATUS[status] || STATUS.entwurf;
  return (
    <span data-testid={testid}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${s.cls}`}>
      {label(status)}
    </span>
  );
}

export function WPScopeNote({ compact = false }) {
  const { t:baseT, lang } = useWP();
  const t = s => packageT(lang, s, baseT);
  return (
    <div data-testid="wp-scope-note"
      className={compact ? "flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-gray-400" : "mb-6 inline-flex flex-wrap items-center gap-2 rounded-lg border border-[#A3E635]/25 bg-[#A3E635]/[0.06] px-3 py-2 text-xs text-gray-300"}>
      <FlaskConical className="w-3.5 h-3.5 text-[#A3E635]" />
      <span className="font-semibold text-[#A3E635]">{t("Preview · Kundenpakete")}</span>
      <span className="text-gray-400">{t("Aufträge, Konzeptansichten und DE/EN-Dokumente. Kein Versand und keine Veröffentlichung.")}</span>
    </div>
  );
}

